<template>
			<b-card class="position-relative mt-3">
				<section>
				
					<div> 
						<!-- <div class="out-of-prefs text-white fs-12 fw-M fam-mont">
							Out of Preferences
						</div> -->
						<!-- int-in-hrs -->
							<div v-if="interview.panelMeetingStatus == 0" class="int-cancelled text-white fs-12 fw-M fam-mont">
							Cancelled
						</div>
					
						<div class="d-flex justify-content-between align-items-center">
							<section style="width: calc(100% - 60px)">
								<article class="id-tag text-3A3C40"><span class="text-blue">ID:</span> {{interview.interviewRequestID}}</article>
								<div class="d-flex align-items-center w-100 gap-2 mt-2" >
									<div :class="interview.image ? 'common-sm-profile-transparet-icon' : 'common-sm-profile-icon'">
									<b-avatar
									v-if="
									interview.image
									"
									:src="interview.image"
								></b-avatar>
									<b-avatar v-else :text="interview.name[0].toUpperCase()"></b-avatar>
									<!-- <div class="pd-kc-dp">
										<img v-if="interview.image" :src="interview.image" alt="" />
						</div> -->
						</div>
						<div class="fs-14 fw-LM fam-lato color-3a3c40 w-75 text-truncate">
									{{interview.name}}
								</div>
								</div>
							</section>
							<section class="d-flex gap-2 align-items-center">
								<img src="../../assets/paneldashboard/viewIcon.svg" alt="">
								<img src="../../assets/paneldashboard/downloadIcon.svg" alt="">
							</section>
						</div>
						<div class="d-flex justify-content-between mts-2">
							<article class="id-tag text-darkgrey">{{interview.slot}}</article>
							<article class="rupee-tag d-flex align-items-center gap-2 fam-mont fw-M color-3a3c40">
								<img src="../../assets/paneldashboard/rupee.svg" alt="">{{interview.amount}}
							</article>
						</div>
					</div>
					<hr style="border-top: 1px solid #8c8c8c" class="my-2 " />
					<div>
						<span class="fam-lato fs-12 fw-LM color-727478"> Role: </span>
						<span class="fam-mont color-3a3c40 fw-M fs-12">
							&nbsp;&nbsp;{{formattedRole}}
						</span>
					</div>
					<div class="mt-1">
						<span class="fam-lato fs-12 fw-LM color-727478"> Skills: </span>
						<span class="fam-mont color-3a3c40 fw-M fs-12">
							&nbsp;&nbsp;{{interview.skills.join(', ')}}
						</span>
					</div>
					<div class="d-flex align-items-center justify-content-end mt-2">
				<div class="mob-addBtn position-relative w-50 ml-2">
							<b-button style="padding: 4px 15px" class="w-100"
								>Give Feedback</b-button
							>
						</div>
			</div>
				</section>
			</b-card>
</template>
<script>
export default {
	name: 'RecentInterviewCard',
	props:{
		interview: Object
	},
	data() {
		return {
			
		};
	},
	computed:{
		 formattedRole() {
      		return this.interview.role.replace(/\b\w/g, (char) => char.toUpperCase());
    		},
	},
	methods:{
		
	}
};
</script>
